module.exports = __webpack_public_path__ + "img/many-discounts.ada6886b.png";